import React from "react";
import { Alert } from "react-bootstrap";

const ErrorMessage = ({ variant = "info", children }) => {
  return (
    <Alert
      variant={variant}
      style={{ fontsize: 20, marginTop: 5, marginBottom: 5 }}
    >
      <strong>{children}</strong>
    </Alert>
  );
};

export default ErrorMessage;
